export const SET_USER = 'SET_USER';
export const SET_ROOMS = 'SET_ROOMS';



// WEBPACK FOOTER //
// ./src/store/actions.js